import axios from "axios";
import * as Config from "../Config";

export const useApi = () => {
  // const getToken = localStorage.getItem("auth") || null;

  const getEvents = (account) => {
    return axios.post(`${Config.API_HOST}/api/get-events`, { account: account });
  };
  const getEvent = (account, event_id) => {
    return axios.post(`${Config.API_HOST}/api/get-event`, { account: account, event_id: event_id });
  };
  const getAccount = (account) => {
    return axios.post(`${Config.API_HOST}/api/get-account`, { account: account });
  };
  const register = (data) => {
    return axios.post(`${Config.API_HOST}/api/register-to-event`, data);
  };
  const checkEmailCoupon = (account, event_id, email) => {
    return axios.post(`${Config.API_HOST}/api/check-email-coupon`, { account: account, event_id: event_id, email: email });
  };

  return {
    getEvents,
    getEvent,
    getAccount,
    register,
    checkEmailCoupon
  };
};
